import useThemeCss from '@/hooks/api/v2/useThemeCss';
import { useEffect } from 'react';

export const useAddThemeCssToDom = () => {
  const { data } = useThemeCss({ refetchOnWindowFocus: 'always' });

  useEffect(() => {
    if (!data) return;

    const existingTag = document.querySelector('[data-name="theme-styles"]');
    if (existingTag) existingTag.parentNode.removeChild(existingTag);

    const style = document.createElement('style');

    style.dataset.name = 'theme-styles';
    style.textContent = data;

    document.head.appendChild(style);
  }, [data]);
};
